import CONFIG from "../../../../globals/config.js";
import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import ChangePassForm from "../components/change-pass-form.js";
export default {
    execute: async () => {
        const { form, submitBtn } = ChangePassForm.get();
        const payload = { email: CONFIG.USER_EMAIL, pass: form.password.value };
        const formRequest = makeFormRequest({ form, submitBtn });
        const route = form.getAttribute('data-route');
        const response = await Request.post(route, payload);
        formRequest.afterResponse(true);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `You have successfully reset your password<br><br>For your own security, you will be redirected to the login page`,
                onRedirect: '/'
            });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
